import { UpsellingVideoView } from '../upselling/UpselingVideoView';
import { UpsellingView } from '../upselling/UpsellingView';
import useRioCookieConsent from '@rio-cloud/rio-uikit/hooks/useRioCookieConsent';
import { useGetUpsellingCampaign } from '../../hooks/useGetUpsellingCampaign';
import { gaPush } from '../../configuration/setup/googleAnalytics';

export const ChatNotBookedView = () => {
    const { getRioCookieConsentInfo } = useRioCookieConsent();
    const upsellingCampaign = useGetUpsellingCampaign();

    const rioCookies = getRioCookieConsentInfo();

    if (upsellingCampaign.type === 'video') {
        if (rioCookies.uxCookiesAccepted) {
            return <UpsellingVideoView campaign={upsellingCampaign} />;
        } else {
            gaPush({
                category: upsellingCampaign.trackingCategory,
                action: 'Video campaign without cookies',
                label: 'Video campaign, but user has not accepted marketing cookies.',
            });
        }
    }

    return <UpsellingView />;
};
